import { e as BarGaugeSizing } from '../../../../../index-B0HfjrH_.js';

"use strict";
const pluginVersion = "12.2.1";
const defaultOptions = {
  minVizHeight: 75,
  minVizWidth: 75,
  showThresholdLabels: false,
  showThresholdMarkers: true,
  sizing: BarGaugeSizing.Auto
};

export { defaultOptions, pluginVersion };
